export default __webpack_public_path__ + "static/media/image_not_available.6c541d2f.jpg";